import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { ITDeleteAccountRequestService } from "../../../../../services/it-delete-account/itDeleteAccountRequest.service";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateDAR = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: IVariable) => ITDeleteAccountRequestService.updateITDeleteAccountRequest(id, body),
  });

  const updateDeleteAccountRequest = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["delete-account-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, updateDeleteAccountRequest, ...restMutation };
};
